import(/* webpackMode: "eager" */ "/vercel/path0/src/app/hakkimizda/page.tsx");
